import {Component, OnDestroy, OnInit} from '@angular/core';
import {NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService} from '@nebular/theme';

import {UserData} from '../../../@core/data/users';
import {LayoutService} from '../../../@core/utils';
import {map, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {AuthService} from '../../../auth/services/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  private data = localStorage.getItem('USER_CURRENT');

  userMenu = [{title: 'Cerrar sesión'}];
  compat: boolean = false;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private _authService: AuthService,
    private router: Router,
  ) {
    this.sidebarService.toggle(this.compat, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
  }

  ngOnInit() {
    // Establecer el tema clásico por defecto
    this.themeService.changeTheme('default');
    
    this.user = JSON.parse(this.data);
    this.menuService.onItemClick().subscribe((event) => {
      this.onItemSelection(event.item.title);
    });
    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = JSON.parse(this.data));

    const {xl} = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  /* tslint:disable:no-console */
  onItemSelection(title) {
    if (title === 'Cerrar sesión') {
      this._authService.logout().subscribe(res => {
        try {
          this.router.navigate(['/login']).then(() => {
            localStorage.clear();
          });
        } catch (error) {
          console.error('Error during logout:', error);
        }
      });
    }
  }

  checkAndNavigate() {
    // Lógica para el botón de notificaciones
  }
}
